export default "__VITE_ASSET__0b971b1e__"